var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "question-circle-fill",
    d: "M16,8A8,8,0,1,1,8,0a8,8,0,0,1,8,8ZM5.5,6.033h.825a.278.278,0,0,0,.266-.25A1.249,1.249,0,0,1,7.929,4.649,1.162,1.162,0,0,1,9.243,5.817c0,.635-.374.927-.965,1.371A2.277,2.277,0,0,0,7.11,9.175l0,.217a.25.25,0,0,0,.25.246h.811a.25.25,0,0,0,.25-.25V9.283c0-.718.273-.927,1.01-1.486a2.44,2.44,0,0,0,1.244-2.056C10.678,4.23,9.4,3.5,8,3.5a2.459,2.459,0,0,0-2.75,2.286.237.237,0,0,0,.241.247Zm2.325,6.443a.938.938,0,1,0,0-1.867.936.936,0,1,0,0,1.867Z",
    transform: "translate(0.5 0.5)",
    fill: "#9a3f82",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.b5e17e3964dd50813c7049c9dc3b3a3e.svg";
export { ForwardRef as ReactComponent };